import axios from 'axios';
class GoogleGA4API {
    constructor() {
        this.accessToken = '';
        // デフォルトでは50件しか取得できないので、1回で取得できる上限の200件に設定する
        this.pageSize = 200;
    }
    setToken(accessToken) {
        this.accessToken = accessToken;
    }
    getGA4Accounts(params) {
        return axios.get(
            `https://analyticsadmin.googleapis.com/v1beta/accounts`,
            {
                headers: {
                    Authorization: 'Bearer ' + this.accessToken
                },
                params: {
                    ...params,
                    pageSize: this.pageSize
                }
            }
        );
    }
    getGA4Properties(params) {
        return axios.get(
            `https://analyticsadmin.googleapis.com/v1beta/properties`,
            {
                headers: {
                    Authorization: 'Bearer ' + this.accessToken
                },
                params: {
                    ...params,
                    pageSize: this.pageSize
                }
            }
        );
    }
    getGA4DataStreams(propertyId, params) {
        return axios.get(
            `https://analyticsadmin.googleapis.com/v1beta/${propertyId}/dataStreams`,
            {
                headers: {
                    Authorization: 'Bearer ' + this.accessToken
                },
                params: {
                    ...params,
                    pageSize: this.pageSize
                }
            }
        );
    }
}

export default new GoogleGA4API();
